import { render, staticRenderFns } from "./idDocInfo.vue?vue&type=template&id=44e7ff56&scoped=true&"
import script from "./idDocInfo.vue?vue&type=script&lang=js&"
export * from "./idDocInfo.vue?vue&type=script&lang=js&"
import style0 from "./idDocInfo.vue?vue&type=style&index=0&id=44e7ff56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e7ff56",
  null
  
)

export default component.exports